import React, {
  useCallback,
  useState,
  useContext,
  useEffect,
  useMemo,
  useRef,
} from 'react'
import { Redirect, } from 'react-router-dom'
import useReactRouter from 'use-react-router'
import queryString from 'query-string'
import { Subject, EMPTY, } from 'rxjs'
import { map, switchMap, catchError, } from 'rxjs/operators'
import { redirectQueryParamKey, } from '@shapr/react-shared/utils/queryParam'
import { AsyncState, } from '@shapr/react-shared/types/Async'
import useAsyncState from '@shapr/react-shared/hooks/useAsyncState'

import GlobalContext from '~/contexts/GlobalContext'
import localStorageConfig from '~/config/localStorageConfig'
import Login from './Login'
import { validateToken as validateTokenRequest, } from './services/loginServices'

const LoginContainer = props => {
  const { history, location, } = useReactRouter()
  const { authToken, setGlobalContext, } = useContext(GlobalContext)
  const parsedQueryParams = useMemo(() => queryString.parse(location.search), [
    location.search,
  ])

  const [tokenInput, setTokenInput,] = useState('')

  const [
    validateTokenStatus,
    validateTokenMessage,
    setValidateTokenState,
  ] = useAsyncState()
  const validateToken$ = useRef(new Subject())
  const validateToken = useRef(undefined)
  useEffect(() => {
    validateToken.current = validateToken$.current
      .pipe(
        switchMap(token => {
          setValidateTokenState(AsyncState.pending)
          return validateTokenRequest({ token, }).pipe(
            map(response => {
              setValidateTokenState(AsyncState.success)
              localStorage.setItem(localStorageConfig.authToken, token)
              setGlobalContext({ authToken: token, })
              history.replace(parsedQueryParams[redirectQueryParamKey] || '/')
            }),
            catchError(error => {
              setValidateTokenState(
                AsyncState.fail,
                error.response.status === 403 ? 'Wrong token' : undefined,
              )
              return EMPTY
            }),
          )
        }),
      )
      .subscribe()
    return () => {
      validateToken.current.unsubscribe()
    }
  }, [])

  const handleLogin = useCallback(newAuthToken => {
    validateToken$.current.next(newAuthToken)
  }, [])

  useEffect(() => {
    if (parsedQueryParams.authToken) handleLogin(parsedQueryParams.authToken)
  }, [parsedQueryParams,])

  if (authToken)
    return <Redirect to={parsedQueryParams[redirectQueryParamKey] || '/'} />

  return (
    <Login
      onLogin={handleLogin}
      onTokenChange={setTokenInput}
      token={tokenInput}
      validateTokenStatus={validateTokenStatus}
      validateTokenMessage={validateTokenMessage}
      {...props}
    />
  )
}

export default LoginContainer
